export const QUILL_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['clean'],
  ],
};

export const QUILL_FORMATS = ['header', 'bold', 'italic', 'underline', 'list', 'bullet'];

/** Convert Quill HTML into structured plain text for AI matching. */
export function htmlToPlainText(html) {
  if (!html || html === '<p><br></p>') return '';
  if (typeof document === 'undefined') {
    return String(html).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }
  const doc = new DOMParser().parseFromString(html, 'text/html');

  doc.querySelectorAll('li').forEach((li) => {
    const parent = li.parentElement;
    const prefix = parent?.tagName === 'OL' ? `${Array.from(parent.children).indexOf(li) + 1}. ` : '• ';
    li.insertAdjacentText('afterbegin', prefix);
  });

  doc.querySelectorAll('h1, h2, h3').forEach((h) => {
    h.insertAdjacentText('beforeend', '\n');
  });

  doc.querySelectorAll('p, div, br, li, ul, ol').forEach((el) => {
    if (el.tagName === 'BR') {
      el.replaceWith(doc.createTextNode('\n'));
      return;
    }
    if (['P', 'DIV', 'LI', 'UL', 'OL'].includes(el.tagName)) {
      el.insertAdjacentText('beforeend', '\n');
    }
  });

  return (doc.body.textContent || '')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

export function isRichTextEmpty(html) {
  return htmlToPlainText(html).length === 0;
}

export function richTextPlainLength(html) {
  return htmlToPlainText(html).length;
}

/** Strip AI markdown fences and keep HTML when present. */
export function sanitizeRichHtml(text) {
  if (!text) return '';
  let s = String(text).trim();
  s = s.replace(/^```[^\n]*\n?/, '');
  s = s.replace(/\n?```\s*$/, '');
  s = s.replace(/^```.*$/gm, '');
  return s.trim();
}

/** Wrap plain text as minimal Quill HTML when loading legacy values. */
export function plainTextToRichHtml(text) {
  const value = (text || '').trim();
  if (!value) return '';
  if (/<[a-z][\s\S]*>/i.test(value)) return value;
  const paragraphs = value.split(/\n{2,}/).map((block) => {
    const lines = block.split('\n').map((line) => line.trim()).filter(Boolean);
    if (lines.every((line) => /^[-•*]\s+/.test(line) || /^\d+\.\s+/.test(line))) {
      const items = lines
        .map((line) => line.replace(/^[-•*]\s+/, '').replace(/^\d+\.\s+/, ''))
        .map((line) => `<li>${escapeHtml(line)}</li>`)
        .join('');
      return `<ul>${items}</ul>`;
    }
    return `<p>${lines.map(escapeHtml).join('<br>')}</p>`;
  });
  return paragraphs.join('');
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}
